import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const ExteriorColor = ({ exteriorColor }: SpecProps<"exterior_color">) => {
  const { i18n } = useLingui();

  if (!exteriorColor) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.exterior_color",
    message: "Exterior color",
    comment: "Field for 'exterior color' in ad specification",
  });
  return <FieldValuePair field={field} value={exteriorColor} />;
};
